import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router';
import BunnyInfoItem from '../components/bunnyInfoItem';
import ExternalLinkWrapper from '../components/externalLinkWrapper';
import { Button } from '../components/ui/button';
import { Skeleton } from '../components/ui/skeleton';
import api from '../lib/api';

const PaymentInformation = () => {
    const { clubId } = useParams();
    const navigate = useNavigate();

    const [info, setInfo] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const amountToPay = searchParams.get('atp');
    const competitionName = searchParams.get('cpn');
    const competitionId = searchParams.get('cid');

    const fetchPaymentInformation = useCallback(async () => {
        try {
            setIsLoading(true); // Use the correct setter function
            const response = await api.get(
                `https://skhrf-api.cmdigital.se/v1/clubs?clubId=${parseInt(clubId)}`
            );
            setInfo(response.data[0].payment_information); // Assuming payment_information is a string
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching payment information:", error);
            setIsLoading(false);
        }
    }, [clubId]);

    useEffect(() => {
        if (clubId) {
            fetchPaymentInformation();
        }
    }, [clubId, fetchPaymentInformation]);

    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <div className='grid grid-cols-1 xl:grid-cols-2 items-center'>
                    <h1 className='font-medium text-2xl'>
                        Tack för din anmälan till {competitionName}!
                    </h1>
                    {/* <div className='grid grid-cols-1 gap-3 pt-3'>
                        <></>
                    </div> */}
                </div>
                <div className='flex flex-col gap-3'>
                    <div>
                        <BunnyInfoItem label='Att betala till föreningen:' value={`${amountToPay} kr`} isLoading={isLoading} />
                    </div>
                    <div>
                        <h2 className='font-medium text-md'>Föreningens betalningsinformation:</h2>
                        {isLoading ? (
                            <Skeleton className='w-full min-h-32' />
                        ) : (
                            <ExternalLinkWrapper>
                                <div
                                    dangerouslySetInnerHTML={{ __html: info }}
                                />
                            </ExternalLinkWrapper>
                        )}
                    </div>
                </div>
                <Button onClick={() => { navigate(`/competition/${competitionId}`); }}>
                    Gå till tävlingen
                </Button>
            </div>
        </div>
    );
};

export default PaymentInformation;
